export const APP_USERS_ROLES_FILTER = {
	_and: [
		{
			role: {
				id: {
					_neq: "33b88ee8-1af3-4b8f-a2aa-ebe5ba596625"
				}
			}
		}
	]
} as any;

export const EDIT_LOCK_DAYS_3 = 3;

export const ROLES = {
	admin: "d6b0779e-70fc-4854-9525-91e41e555389",
	shilan: "272be022-2246-4bfc-867b-3c14bd6d54b9",
	neurofeedback_director: "af059eb1-ed68-4fb1-a0bd-a0a122f21eed",
	reception_director: "444915ca-8738-4b34-8e1c-fb3da4a54d03",
	technical_director: "c3aaca5c-9e37-499e-b061-74690007fe0f",
	nfb_techncians: "55720c74-c013-44f0-96e5-3737adf14963",
	nfb_and_theurapist: "2d7fadc9-2996-439c-9568-b30ecffd91cd",
	theurapist: "0295dd26-17ab-454c-bacf-044dd349f21e",
	recepcionist: "3b835836-7e73-4f72-af50-597f9a49261f",
	substituion_joana_temp: "e18a39d7-1b01-493d-9448-1c861b9f1b50",
	other: "0675b953-7b2a-4778-b578-2818b22794d8",
	accounting: "83e16f3b-d544-433d-8f55-466c51b1246a",
	virtual_assistant: "be3622e2-3796-4458-9c8f-e4738c5b4524",
	callcenter: "ef356faa-3c5e-4f8d-851f-e9fb14fcc372",
	tech_people: "96282fd0-acd0-4db4-970a-641e9ca271ab",
	clients: "33b88ee8-1af3-4b8f-a2aa-ebe5ba596625",
	marketing_bot: "b81935bf-74f0-47c4-a336-f9492743a3df",
	make: "3b3ae5ad-b291-47fb-ad33-2d1af245ec26",
	finance_bot: "6bbc3119-155e-49b3-a671-d2097386f0af",
	tech_admin: "92f2d076-30b7-4e39-b9fc-48a9e706e1e2",
	human_resources: "4813fdfc-8ab1-4086-a142-7213b0813a1c",
	client_owner: "1acd9f00-215a-4407-84c1-e68a1d56d2b8",
	human_resources_manager: "4813fdfc-8ab1-4086-a142-7213b0813a1c",
	back_office: "e44125ef-649a-413a-ba6f-a5e3080d5985",
	marketing_manager: "f15cff80-b48d-4db8-a376-e548ab782801"
};

export const PAYMENTS_STAFF_ROLE_IDS: Array<string> = [
	ROLES.admin,
	ROLES.shilan,
	ROLES.technical_director,
	ROLES.recepcionist,
	ROLES.back_office
];

export const LIVE_CALLS_ROLE_IDS: Array<string> = [
	ROLES.callcenter,
	ROLES.recepcionist,
	ROLES.back_office,
	ROLES.admin,
	ROLES.shilan,
	ROLES.technical_director,
	ROLES.marketing_manager
];

export const isLiveCallsRole = (roleId: string | undefined) => {
	if (!roleId) {
		return false;
	}
	const matches = LIVE_CALLS_ROLE_IDS.includes(roleId);
	return matches;
};

export const KIOSK_CALLBACK_ROLE_IDS: Array<string> = [ROLES.back_office, ROLES.recepcionist];

export const isKioskCallbackRole = (roleId: string | undefined) => {
	if (!roleId) {
		return false;
	}
	const matches = KIOSK_CALLBACK_ROLE_IDS.includes(roleId);
	return matches;
};

export const LIVE_CALLS_SUPERVISOR_ROLE_IDS: Array<string> = [
	ROLES.admin,
	ROLES.technical_director,
	ROLES.marketing_manager
];

export const isLiveCallsSupervisor = (roleId: string | undefined) => {
	if (!roleId) {
		return false;
	}
	const matches = LIVE_CALLS_SUPERVISOR_ROLE_IDS.includes(roleId);
	return matches;
};

export const NFB_ASSIGN_WIDGET_ROLE_IDS: Array<string> = [
	ROLES.admin,
	ROLES.shilan,
	ROLES.neurofeedback_director,
	ROLES.client_owner,
	ROLES.nfb_techncians,
	ROLES.nfb_and_theurapist,
	ROLES.recepcionist,
	ROLES.tech_admin,
	ROLES.technical_director,
	ROLES.reception_director,
	ROLES.back_office
];

export const isNfbAssignWidgetRole = (roleId: string | undefined) => {
	if (!roleId) {
		return false;
	}
	const matches = NFB_ASSIGN_WIDGET_ROLE_IDS.includes(roleId);
	return matches;
};

export const SPECIAL_USERS = {
	joana_director: "453f4b6d-3bd8-4838-ba27-36c6bc43e5e7",
	filipa_nfb_director: "79ae2166-3997-4581-905c-7533eaca2977",
	reception_porto: "272434b3-4b10-412b-b671-2271b3f836cb",
	reception_braga: "3f86858d-3f63-416c-b163-206db7382308",
	shilan: "c6ff41ec-ef5d-48e4-b874-94b9d48e69c8",
	nfb_team: "dbc7e39f-11f2-4209-9b2b-8faa7987f2fc",
	maria_antunes: "a7582027-3906-4f4f-ae19-3b9a890d7053",
	jorge_perestrelo: "9b0bad79-56a2-43a8-b1c8-bc8ac8e48462"
};

export const NIC_USERS = {
	daniela_lemos: "312e4eae-1112-43c0-889d-023608c0f7d5",
	beatriz_pinho: "124b373c-03cd-4bca-ab42-63a91b849b3d"
};

export const weekDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export const weekDaysTranslation: Record<string, string> = {
	Monday: "Segunda-feira",
	Tuesday: "Terça-feira",
	Wednesday: "Quarta-feira",
	Thursday: "Quinta-feira",
	Friday: "Sexta-feira",
	Saturday: "Sábado",
	Sunday: "Domingo"
};

export const OVERBOOKED_RATIO = 0.9;

export const CATEGORIES_CONFIG = {
	nfb: {
		key: "nfb",
		name: "Neurofeedback",
		services: [
			{
				id: 33
			},
			{
				id: 35
			},
			{
				id: 39
			}
		],

		duration: 45,
		timeForSessions: 1
	},
	psy: {
		key: "psy",
		name: "Psychology",
		services: [
			{
				id: 34
			},
			{
				id: 36
			}
		],

		duration: 60,
		timeForSessions: 1
	},
	reports: {
		key: "reports",
		name: "Reports",
		services: [
			{
				id: 37
			},
			{
				id: 40
			},
			{
				id: 50
			}
		],
		duration: 45,
		timeForSessions: 1
	},
	others: {
		key: "others",
		name: "Others",
		services: [],
		duration: 60,
		timeForSessions: 1
	}
};

export const CLINIC_SCHEDULES = {
	morning: {
		start: { hours: 9, minutes: 0 },
		end: { hours: 13, minutes: 0 }
	},
	afternoon: {
		start: { hours: 14, minutes: 0 },
		end: { hours: 21, minutes: 0 }
	}
};

export const CLINIC_BREAKS = {
	lunch: {
		start: { hours: 13, minutes: 0 },
		end: { hours: 14, minutes: 0 }
	},
	afternoon: {
		start: { hours: 17, minutes: 0 },
		end: { hours: 17, minutes: 15 }
	}
};

export const MAX_WORK_HOURS = {
	day: 10,
	week: 41
};

export const FIRST_ROOMS_ID = {
	nfb: 1,
	psy: 6
};

export const ORDERS_SINCE_DATE = "2025-01-01";

export const BANK_TRANSACTIONS_SINCE_DATE = "2025-01-01";

export const CASH_ACCOUNT_ID = 92;

export const TIMEZONE = "Europe/Lisbon";

export const FIRST_EEG_SERVICE = 39;
export const GENERAL_EEG_SERVICE = 35;
export const EEG_SERVICES = [GENERAL_EEG_SERVICE, FIRST_EEG_SERVICE];
export const NFB_SERVICE = 33;
export const PSY_SERVICE = 34;
export const REPORTS_FIRST_SERVICE = 37;
export const REPORTS_SERVICE = 40;
export const FOLLOWUP_SERVICE = 50;
export const PARENTAL_COUNSELLING_SERVICE = 52;

export const MAKE_WEBHOOKS = {
	google_meet: "https://hook.eu1.make.com/bnvtjymu2qdcwjfm89u7l1iwozojw4tr",
	send_payment_link_email: "https://hook.eu1.make.com/nrhi0jxouuwnitrygtujjwhbe3odj992",
	create_receipt: "https://hook.eu1.make.com/pvyiyamem3ntxztplwl4itp25djglrw3",
	upload_staff_salaries_finance: "https://hook.eu1.make.com/8w7mxqlazbu3e3tq8s66ui6lyr01on2e",
	send_staff_receipts_finance: "https://hook.eu1.make.com/gjxcek1i9alcuedbbjw5jdkhaeyfsf22",
	send_email_with_optional_attachment: "https://hook.eu1.make.com/58vlxe4hrf3iawoxalaye2qbdhxcn6fr",
	send_payment_info_emails: "https://hook.eu1.make.com/4h5f3kfmbknxqu3uahx0p8rfngy51ud7",
	send_app_download_email: "https://hook.eu1.make.com/ajaaoj6f2hxx2l4381pencmc4ja4si63"
};

export const TREATMENTS_TO_EXCLUDE = ["2688", "607000946", "607000893"]; // Internal employees that do not pay for their treatments

export const STALE_TIME_24H = 24 * 60 * 60 * 1000;

export const STALE_TIME_1H = 60 * 60 * 1000;

export const INSURANCE_AGREEMENT_ID = 6;

export const VIRTUAL_CLINIC_ID = 2;

export const CLINICS: Record<string, string> = {
	"1": "Porto",
	"2": "Virtual",
	"3": "Braga"
};
